import React from "react";
import "./flight-detail.scss";
import { Link } from "react-router-dom";

const FlightDetailSection = () => {
  return (
    <section className="flight-detail-section">
      <div className="download-ticket">
        <Link>
          {" "}
          <img src="/images/icons/ticket.svg" alt="icon" /> Download ticket
        </Link>
      </div>
      <div className="flight-routes">
        <div className="from">
          <h3>(CGK)</h3>
          <p>Jakarta, Indonesia</p>
        </div>
        <div className="time">
          <img src="/images/icons/flight-time-icon.svg" alt="flight" />
          <p className="total-duration">1HR 30MIN</p>
        </div>
        <div className="to">
          <h3>(DPS)</h3>
          <p>Jakarta, Indonesia</p>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3 col-md-6">
          <div className="flight-info-box">
            <img src="/images/icons/travel-time.svg" alt="icon" />
            <div className="details">
              <span>Total travel Time</span>
              <p>8h 50m</p>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6">
          <div className="flight-info-box">
            <img src="/images/icons/booking-ref.svg" alt="icon" />
            <div className="details">
              <span>Booking Reference</span>
              <p>ABC123XYZ</p>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6">
          <div className="flight-info-box">
            <img src="/images/icons/passenger.svg" alt="icon" />
            <div className="details">
              <span>Passenger</span>
              <p>Ahmad Abdul Quddus</p>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6">
          <div className="flight-info-box">
            <img src="/images/icons/air-booking-ref.svg" alt="icon" />
            <div className="details">
              <span>Airline Booking Reference</span>
              <p>176-XXXXXXX</p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="flight-info-box">
            <img src="/images/icons/baggage.svg" alt="icon" />
            <div className="details">
              <span>Baggage</span>
              <p>1x Carry-on Included. No checked baggage (as per fare) </p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="flight-info-box">
            <img src="/images/icons/note-flight.svg" alt="icon" />
            <div className="details">
              <span>Note</span>
              <p>This is a non-refundable fare Changes not permitted.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="flight-item-box">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-3 py-0">
            <div className="air-line">
              <img src="/images/icons/emirates.svg" alt="airline" />
              <p>Emirates, A380</p>
            </div>
          </div>
          <div className="col-lg-4 py-0">
            <div className="flight-row">
              <div className="title">
                <h5>13:30</h5>
                <p>LHR</p>
              </div>
              <div className="time-duration">
                <p>8h 50m</p>
                <img src="/images/icons/flight-row.svg" alt="flight-row" />
                <p>5h in Karachi</p>
              </div>
              <div className="title to">
                <h5>13:30</h5>
                <p>LHR</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 py-0">
            <div className="price-wrap">
              <Link to="/flight-details" className="flight-select">
                See Details
              </Link>
            </div>
          </div>
        </div>
        <div className="badges">
          <div className="badge-cheap">Cheapest</div>
          <div className="badge-light">
            {" "}
            <img src="/images/icons/carry.svg" alt="icon" /> Carry-on baggage
            included
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlightDetailSection;
